import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { initTheme } from "./lib/theme";
import "./fonts.css";
import "./styles.css";
import "./private-office.css";

// Put the remembered (or OS) theme on <html> before React mounts, so the dark
// tokens are in place before the first paint rather than flashing light first.
initTheme();

const root = document.getElementById("root");
if (!root) throw new Error("No #root element. index.html is wrong.");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
